import { useMemo } from "react";

import {
  useListContext,
  useListFilterValues,
  useListMetadata,
} from "@/modules/list";

import {
  convertFiltersToChartSelectedLegend,
  convertChartSelectedLegendToFilters,
} from "./ListStatisticsHelpers";

export const useListStatistics = ({ statsDataKey, filterKey }) => {
  const { loading, fetching, clearFilter, onFilterChange } = useListContext();

  const filters = useListFilterValues(filterKey);
  const statsData = useListMetadata(`statistics.${statsDataKey}`, []);

  return {
    loading,
    fetching,
    statsData,
    filters,
    clearFilter,
    onFilterChange,
  };
};

export const useLimitStatsData = ({ statsData, limit, othersKey }) => {
  if (
    typeof limit !== "number" ||
    limit <= 0 ||
    typeof statsData !== "object" ||
    Object.keys(statsData).length <= limit
  ) {
    return statsData;
  }

  const formated = Object.entries(statsData)
    .sort(([, a], [, b]) => b - a)
    .reduce((statistic, [key, value], index) => {
      if (index < limit) {
        statistic[key] = value;
      } else {
        statistic[othersKey] = (statistic[othersKey] || 0) + value;
      }
      return statistic;
    }, {});

  return formated;
};

export const useListDonutChartSelected = ({ filterKey, chartData }) => {
  const { onFilterChange } = useListContext();

  const filters = useListFilterValues(filterKey);

  const onLegendSelectChange = ({ selected }) => {
    const filterValues = convertChartSelectedLegendToFilters(selected);
    onFilterChange({ filterKey, filterValues });
  };

  const legendKeys = useMemo(
    () => chartData.map(({ name }) => name),
    [chartData]
  );

  const selectedLegend = useMemo(
    () => convertFiltersToChartSelectedLegend(legendKeys, filters),
    [legendKeys, filters]
  );

  return {
    selectedLegend,
    onLegendSelectChange,
  };
};
